export const STORIES_LIST_CONTENT = {
  archiveConfirmText: 'Вы уверены, что хотите архивировать сюжет?',
  archiveFirstSentenseText: 'Сюжет не будет виден на сайте и будет недоступен для добавления новых публикаций.',
  storiesNotFound: 'Сюжеты отсутствуют',
  deleteConfirmText: 'Вы не сможете его восстановить или отредактировать.',
  deleteFirstSentenseText: 'Вы уверены, что хотите удалить сюжет?',
  storyStatusChangedSuccessfully: 'Статус сюжета изменен успешно',
  unzipConfirmText: 'Сюжет появится на сайте и будет доступен для добавления новых публикаций.',
  unzipFirstSentenseText: 'Вы уверены, что хотите разархивировать сюжет?',
  yes: 'Да',
  yesDelete: 'Да, удалить'
}
